import styled from 'styled-components'

export const Style = styled.div`
  margin-bottom: 90px;
  margin-top: 90px;
  display: block;
  width: 100%;
  .card-vendor {
    .image {
      width: 120px;
      margin-bottom: 10px;
      img {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    margin-bottom: 50px;
    margin-top: 50px;
    .card-vendor {
      border: solid 2px #dddddd;
      border-radius: 20px;
      justify-content: unset;
      padding: 24px 16px;
      .image {
        display: flex;
        width: 80px;
        height: 80px;
        justify-content: center;
        align-items: center;
      }
      .title {
        margin-top: 0;
        font-size: 18px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #555555;
      }
    }
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
  .row-align-items {
    align-items: flex-end;
  }
  .card-vendor-width {
    width: 100%;
  }
`
